import React, { useContext, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import BackgroundCarousel from '../../BackgroundCarousel/BackgroundCarousel';
import { CustomerContext } from '../../../contexts/CustomerContext';
import Typography from '../../Typography';
import Button from '../../Button';
import styles from './BackgroundSelection.module.sass';
import PreviewImage from '../../PreviewImage/PreviewImage';
import Spinner from '../../Spinner';
import { StudentImage, Package } from '../../../models/_models';
import placeholder from '../../../assets/placeholder_elementary.png';
import useLocalStorage from "../../../hooks/useLocalStorage";

const BackgroundSelection = () => {
  const { package_id } = useParams();
  const history = useHistory();
  const { customer, setCustomer } = useContext(CustomerContext);
  const [backgrounds, setBackgrounds] = useState([]);
  const [studentImage, setStudentImage] = useState(customer.currentOrderPackage.studentImage);
  const [fetchCount, setFetchCount] = useState(0);
  const [selectedBackground, setSelectedBackground] = useState();
  const [componentLoaded, setComponentLoaded] = useState(0)
  const [currentPackage, setCurrentPackage] = useState()
  const currentStudent = customer.currentStudent;
  const [currentSeason] = useLocalStorage(`currentSeason-${currentStudent.id}`)

  const selectionHandler = background => setSelectedBackground(background);
  const increment = () => setComponentLoaded(prev => prev + 1)

  useEffect(() => {
    Package
      .includes({ backgroundSet: 'backgrounds' })
      .find(package_id)
      .then(res => {
        setCurrentPackage(res.data)
        if (res.data && res.data.backgroundSet && res.data.backgroundSet.backgrounds.length > 0) setBackgrounds(res.data.backgroundSet.backgrounds);
        setFetchCount(prev => prev + 1)
      })
  }, []);

  useEffect(() => {
    if (studentImage) {
      setFetchCount(prev => prev + 1)
      return
    }

    const seasonParam = currentSeason ? { eq: currentSeason } : { match_for_package: package_id }

    StudentImage
      .where({ folder: seasonParam })
      .where({ studentId: currentStudent.id })
      .all()
      .then(res => {
        const sortedData = res.data
          .filter(image => image.imageUrl !== "/images/original/missing.png")
          .sort((a, b) => {
            if (a.folder === b.folder)
              return a.createdAt.localeCompare(b.created_at);
            else
              return a.folder.localeCompare(b.folder);
          });

        setStudentImage(sortedData[sortedData.length - 1]);
        setFetchCount(prev => prev + 1)
      });
  }, []);

  const handleContinue = () => {
    customer.currentOrderPackage.backgroundId = selectedBackground.id;
    customer.currentOrderPackage.studentId = customer.currentStudent.id;
    customer.currentOrderPackage.background = selectedBackground;
    customer.currentOrderPackage.student = customer.currentStudent;

    if (studentImage) {
      customer.currentOrderPackage.studentImage = studentImage;
      customer.currentOrderPackage.studentImageId = studentImage.id;
    }

    setCustomer({ ...customer, currentOrderPackage: customer.currentOrderPackage });
    history.push(`/option_selection/${package_id}`);
  };

  if (fetchCount < 2) return <div style={{ width: '100%', minHeight: '90vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}><Spinner color='blue' /></div>;

  let previewImage = placeholder
  if (studentImage && studentImage.watermarkUrl) {
    previewImage = studentImage.watermarkUrl
  } else if (currentPackage && !currentPackage.placeholder.includes('placeholder.png')) {
    previewImage = currentPackage.placeholder
  }

  return (
    <div className={componentLoaded < 2 && styles.hidden}>
      <div className={styles.outerPreviewContainer}>
        <div className={styles.previewContainer}>
          <Typography weight={700}>PREVIEW</Typography>
          <div className={styles.innerContainer}>
            {selectedBackground &&
              <PreviewImage onLoad={increment} foregroundUrl={previewImage} backgroundUrl={selectedBackground.imageUrl} />
            }
          </div>
        </div>
      </div>
      <BackgroundCarousel onLoad={increment} backgrounds={backgrounds} onSelection={selectionHandler} defaultBg={customer.currentOrderPackage.background} />
      <div
        style={{ width: '90%', margin: '16px auto', maxWidth: '576px' }}
      >
        <Button fullWidth variant="primary" classes={styles.continueBtn} onClick={handleContinue}>
          Continue
        </Button>
      </div>
    </div>
  );
};

export default BackgroundSelection;
